module.exports = __webpack_public_path__ + "static/media/PTSans-Regular.4ea26cd5.ttf";